// extracted by mini-css-extract-plugin
export default {"formWrapper":"EditFormModalWithTextInputFlags_formWrapper__SO6H+"};